"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackagingMethod = void 0;
var PackagingMethod;
(function (PackagingMethod) {
    PackagingMethod["Envelope"] = "Envelope";
    PackagingMethod["Pdf"] = "Pdf";
    PackagingMethod["GiftBox"] = "GiftBox";
})(PackagingMethod || (exports.PackagingMethod = PackagingMethod = {}));
//# sourceMappingURL=PackagingMethod.js.map